export default {
    SET_ACCOUNT_DETAILS: 'SET_ACCOUNT_DETAILS',
};
